import { Pipe, PipeTransform } from '@angular/core';
import { PhoneNumberUtil, PhoneNumberFormat } from 'google-libphonenumber';

@Pipe({
    name: 'phone',
    standalone: false
})
export class PhonePipe implements PipeTransform {
    transform(value: string, _args?: any): string {
        let pnu: PhoneNumberUtil = PhoneNumberUtil.getInstance();
        let phone: any;

        try {
            phone = pnu.parse('+' + value, '');
        } catch (e) {
            return value;
        }

        if (phone && pnu.isValidNumber(phone)) {
            return pnu.format(phone, PhoneNumberFormat.NATIONAL);
        } else {
            return value;
        }
    }
}
